if (!window.Eurus.loadedScript.includes('preview-color-swatches.js')) {
  window.Eurus.loadedScript.push('preview-color-swatches.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xProductCard', (
        sectionId,
        productUrl,
        productId,
      ) => ({
        currentVariantCard: '',
        options: [],
        isSelect: false,
        productId: productId,
        showOptions: false,
        loading: false,
        errorMessage: false,
        init() {
          document.addEventListener(`eurus:product-card-variant-select:updated:${sectionId}`, (e) => {
            this.checkVariantSelected();
            this.currentVariantCard = e.detail.currentVariant;
            this.options = e.detail.options;
          });

          // Speed 2026-09-16: boot this card when it is near the viewport instead
          // of all 20-96 cards fighting for rAF on first paint (collection INP
          // 280-504ms). Hover/swatch behavior is identical once the card is seen.
          const boot = () => this.initializeProductCard();
          if (typeof IntersectionObserver !== 'undefined' && this.$el) {
            const io = new IntersectionObserver((entries, obs) => {
              if (entries.some((entry) => entry.isIntersecting)) {
                obs.disconnect();
                this.$nextTick(boot);
              }
            }, { rootMargin: '200px' });
            io.observe(this.$el);
          } else {
            this.$nextTick(boot);
          }

          // ONE grid observer for the whole page, not one per card.
          if (!window.__liliProductGridHoverObserver) {
            window.__liliProductGridHoverObserver = true;
            const bindGridObserver = () => {
              const productGridContainer = document.getElementById('ProductGridContainer');
              if (!productGridContainer || productGridContainer.dataset.liliObserved) return;
              productGridContainer.dataset.liliObserved = '1';
              const observer = new MutationObserver(() => {
                requestAnimationFrame(() => {
                  if (window.Alpine && window.Alpine.store('xPreviewColorSwatch')) {
                    window.Alpine.store('xPreviewColorSwatch').createHoverImagesForAllCards();
                  }
                });
              });
              observer.observe(productGridContainer, { childList: true });
            };
            if (document.readyState === 'loading') {
              document.addEventListener('DOMContentLoaded', bindGridObserver, { once: true });
            } else {
              bindGridObserver();
            }
          }
        },
        
        initializeProductCard() {
          // Initialize this specific product card
          if (window.Alpine && window.Alpine.store('xPreviewColorSwatch')) {
            const card = this.$el;
            if (card) {
              // Wait for swatch slider and current variant to be ready
              let retryCount = 0;
              const maxRetries = 12;
              
              const waitForElements = () => {
                if (card.querySelector('.swatch-slider') && card.querySelector('.current-variant')) {
                  // Scroll to selected variant
                  window.Alpine.store('xPreviewColorSwatch').scrollToSelectedVariant(card, sectionId);
                  
                  // Create hover image
                  const currentVariantElement = card.querySelector('.current-variant');
                  const currentVariantId = currentVariantElement ? currentVariantElement.textContent.trim() : this.productId;
                  window.Alpine.store('xPreviewColorSwatch').updateSecondImage(card, currentVariantId);
                } else if (retryCount < maxRetries) {
                  // Check again on next frame
                  retryCount++;
                  requestAnimationFrame(waitForElements);
                }
                // If max retries reached, silently fail
              };
              
              waitForElements();
            }
          }
        },
        
        checkVariantSelected() {
          const fieldset = [...document.querySelectorAll(`#variant-update-${sectionId} fieldset`)];
          if(fieldset.findIndex(item => !item.querySelector("input:checked")) == "-1") {
            this.isSelect = true;
          }
        }
      }))

      Alpine.data('xDoubleTouch', (productUrl, waitForDoubleTap) => ({
        lastTapTime: 0,
        DOUBLE_TAP_DELAY: 300,
        singleTapTimeout: null,
        touchStartX: 0,
        touchStartY: 0,
        touchMoved: false,
        MAX_MOVE_THRESHOLD: 10,
        showSecond: false,

        onTouchStart(event) {
          const touch = event.touches[0];
          this.touchStartX = touch.clientX;
          this.touchStartY = touch.clientY;
          this.touchMoved = false;
        },
  
        onTouchMove(event) {
          const touch = event.touches[0];
          const deltaX = Math.abs(touch.clientX - this.touchStartX);
          const deltaY = Math.abs(touch.clientY - this.touchStartY);
          if (deltaX > this.MAX_MOVE_THRESHOLD || deltaY > this.MAX_MOVE_THRESHOLD) {
            this.touchMoved = true;
          }
        },
  
        onTouchEnd(splide, carousel) {
          if (this.touchMoved) {
            return;
          }
          // Speed 2026-09-16: navigate on first tap. The 300ms double-tap
          // wait was the collection INP floor (tiles p75 504ms). Desktop
          // hover still flips the second image; mobile tap goes to the PDP.
          this.onSingleTap();
        },
  
        onSingleTap() {
          window.location.href= productUrl
        },
  
        onDoubleTap(splide, carousel) {
          if (carousel) {
            Alpine.store('xSplide').togglePlayPause(splide)
          } else {
            if (this.showSecond == true) {
              this.showSecond = false;
            } else {
              this.showSecond = true;
            }
          }        
        }
      }));

      Alpine.store('xPreviewColorSwatch', {
        _productDataCache: new WeakMap(),

        expandDeferredSwatches(el) {
          const cardProduct = el.closest('.card-product');
          if (!cardProduct) return;

          const container = el.closest('.swatch-container') || cardProduct;

          // Immediate click feedback — keep INP low; heavy DOM/JSON/Splide after paint.
          container.querySelectorAll('[data-swatch-expand]').forEach((btn) => {
            btn.remove();
          });

          const applyDeferred = () => {
            const deferredLabels = container.querySelectorAll('label.color-watches[data-bg-image]');
            const cssChunks = [];
            deferredLabels.forEach((label) => {
              const raw = label.getAttribute('data-bg-image');
              if (!raw) return;

              if (raw.startsWith('swatch-file:')) {
                const fileUrl = raw.slice('swatch-file:'.length);
                const swatchKey = label.getAttribute('data-swatch');
                if (swatchKey) {
                  const safeKey = (typeof CSS !== 'undefined' && CSS.escape)
                    ? CSS.escape(swatchKey)
                    : String(swatchKey).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
                  cssChunks.push(`[data-swatch="${safeKey}"]:before { background-image: url(${fileUrl}); }`);
                }
              } else if (raw.startsWith('background:')) {
                label.setAttribute('style', raw.endsWith(';') ? raw : `${raw};`);
              } else {
                raw.split(';').forEach((part) => {
                  const trimmed = part.trim();
                  if (!trimmed) return;
                  const colon = trimmed.indexOf(':');
                  if (colon === -1) return;
                  const prop = trimmed.slice(0, colon).trim();
                  const value = trimmed.slice(colon + 1).trim();
                  if (prop) label.style.setProperty(prop, value);
                });
              }
              label.removeAttribute('data-bg-image');
            });

            if (cssChunks.length) {
              const styleEl = document.createElement('style');
              styleEl.textContent = cssChunks.join('\n');
              document.head.appendChild(styleEl);
            }

            container.querySelectorAll('.swatch-slide--deferred').forEach((slide) => {
              slide.classList.remove('swatch-slide--deferred');
            });
            container.querySelectorAll('.swatch-input--deferred').forEach((input) => {
              input.classList.remove('swatch-input--deferred');
            });

            const legacyDeferred = container.querySelector('.swatch-deferred');
            if (legacyDeferred) {
              legacyDeferred.hidden = false;
              legacyDeferred.classList.add('is-expanded');
            }

            this.mergeDeferredProductMedia(cardProduct);

            // Keep is-collapsed + pending until Splide mounts so .splide { visibility:hidden }
            // does not blank the preview while the slider script loads.
            this.initPlusNSlider(container);
          };

          requestAnimationFrame(() => {
            setTimeout(applyDeferred, 0);
          });
        },

        initPlusNSlider(container) {
          const sliderEl = container.querySelector('[data-plus-n-pending]');
          if (!sliderEl || !window.Alpine || !Alpine.store('xSplide')) {
            container.classList.remove('is-collapsed');
            return;
          }

          const finalizeExpand = () => {
            sliderEl.removeAttribute('data-plus-n-pending');
            sliderEl.classList.remove('swatch-slider--plus-n-pending');
            container.classList.remove('is-collapsed');
          };

          Alpine.store('xSplide').load(sliderEl, {
            autoWidth: true,
            perMove: 1,
            gap: 0,
            arrows: true,
            pagination: false,
            drag: true,
            type: 'slide',
            rewind: false,
            trimSpace: true,
            focus: 0,
            updateOnMove: true,
            classes: {
              arrow: 'splide__arrow',
              prev: 'splide__arrow--prev',
              next: 'splide__arrow--next'
            },
            events: [
              {
                event: 'mounted',
                callback: finalizeExpand
              }
            ]
          });
        },

        mergeDeferredProductMedia(cardProduct) {
          const productId = cardProduct.dataset.productId;
          if (!productId) return;

          const deferredEl = cardProduct.querySelector(`script[data-deferred-product-media="${productId}"]`);
          const productDataEl = cardProduct.querySelector(`script[data-product-data="${productId}"]`);
          if (!deferredEl || !productDataEl) return;

          let deferredData;
          let productData;
          try {
            deferredData = JSON.parse(deferredEl.textContent);
            productData = JSON.parse(productDataEl.textContent);
          } catch (e) {
            return;
          }

          if (Array.isArray(deferredData.media) && deferredData.media.length) {
            const existingIds = new Set((productData.media || []).map((m) => m.id));
            deferredData.media.forEach((media) => {
              if (!existingIds.has(media.id)) {
                productData.media = productData.media || [];
                productData.media.push(media);
                existingIds.add(media.id);
              }
            });
          }

          const featuredMap = deferredData.variant_featured_images || {};
          if (productData.variants && Object.keys(featuredMap).length) {
            productData.variants.forEach((variant) => {
              const featured = featuredMap[String(variant.id)] || featuredMap[variant.id];
              if (featured) {
                variant.featured_image = featured;
              }
            });
          }

          productDataEl.textContent = JSON.stringify(productData);
          deferredEl.remove();
          this.invalidateProductData(cardProduct);
          this._productDataCache.set(cardProduct, productData);
        },

        onChangeVariant(el, productUrl, src, variantId, sectionId, isColor = false) {
          // Find the Alpine.js component and trigger variant update
          const cardProduct = el.closest('.card-product');
          let currentVariant = null;
          let didSelector = false;
          if (cardProduct) {
            const variantUpdateContainer = cardProduct.querySelector(`[id^="variant-update-${sectionId}"]`);
            if (variantUpdateContainer) {
              // Find the Alpine.js component instance
              const alpineComponent = variantUpdateContainer._x_dataStack?.[0];
              if (alpineComponent && alpineComponent._updateVariantSelector) {
                // Trigger variant update immediately (also updates image via _updateImageVariant).
                alpineComponent._updateVariantSelector();
                currentVariant = alpineComponent.currentVariant;
                didSelector = true;
              }
            }
          }

          // Avoid document listener leak (old code added a new listener every click).
          // Only call updateImage when selector didn't already handle it.
          if (!didSelector || !currentVariant) {
            this.updateImage(el, productUrl, src, currentVariant ? currentVariant.id : variantId, sectionId);
          }
          requestAnimationFrame(() => {
            this.scrollToSelectedVariant(el, sectionId);
          });

          if (!isColor) {
            let productVariants = ''

            document.dispatchEvent(new CustomEvent(`eurus:product-variant-get:${sectionId}`, {
              detail: {
                callback: (variants) => {
                  productVariants = variants;
                }
              }
            }));

            if (productVariants) {
              const getSwatchImageUrl = (imageSrc, size = 128) => {
                if (!imageSrc) return imageSrc;
                let url = imageSrc
                  .replace(/([?&])width=\d+/g, '$1')
                  .replace(/([?&])height=\d+/g, '$1')
                  .replace(/([?&])crop=[^&]*/g, '$1')
                  .replace(/\?&/, '?')
                  .replace(/[?&]$/, '')
                  .replace(/\?$/, '');
                return `${url}${url.includes('?') ? '&' : '?'}width=${size}&height=${size}&crop=center`;
              };
              const normalizeSwatchBg = (value) => {
                if (!value) return '';
                const raw = value.replace(/^url\((['"]?)(.*)\1\)$/, '$2');
                try {
                  const full = raw.startsWith('//') ? `https:${raw}` : raw;
                  const parsed = new URL(full);
                  return `${parsed.pathname}|${parsed.searchParams.get('width') || ''}|${parsed.searchParams.get('height') || ''}`;
                } catch {
                  return raw;
                }
              };
              const swatchesContainer = el.closest('.options-container');
              if (swatchesContainer) {
                const swatches = swatchesContainer.querySelectorAll('label.color-watches');
                if (!swatches.length) return;

                const inputs = swatchesContainer.querySelectorAll('input:checked');
                const selectedOption = [];

                inputs.forEach(input => {
                  if (![...swatches].some(swatch => swatch.dataset.optionvalue === input.value)) {
                    selectedOption.push(input.value);
                  }
                });

                if (!selectedOption.length) return;

                const variantSrc = productVariants.reduce((acc, variant) => {
                  if (variant.featured_image) {
                    acc[variant.id] = getSwatchImageUrl(variant.featured_image.src);
                  }
                  return acc;
                }, {});

                const imageSrc = productVariants
                  .filter(variant => selectedOption.every(option => variant.options.includes(option)))
                  .map(variant => `url(${variantSrc[variant.id] ? variantSrc[variant.id] : getSwatchImageUrl(src)})`);

                swatches.forEach((swatch, index) => {
                  const next = imageSrc[index];
                  if (!next) return;
                  if (normalizeSwatchBg(swatch.style.getPropertyValue('--bg-image')) === normalizeSwatchBg(next)) return;
                  swatch.style.setProperty('--bg-image', next);
                });
              }
            }
          } 
        },

        scrollToSelectedVariant(el, sectionId) {
          const cardProduct = el.closest('.card-product');
          if (!cardProduct) return;

          // Find all swatch sliders in this product card
          const swatchSliders = cardProduct.querySelectorAll('.swatch-slider');
          
          swatchSliders.forEach((slider, sliderIndex) => {
            // Find the checked input within this slider
            const checkedInput = slider.querySelector('input:checked');
            if (!checkedInput) return;

            // Find the label that corresponds to this input
            const inputId = checkedInput.id;
            const correspondingLabel = slider.querySelector(`label[for="${inputId}"]`);
            if (!correspondingLabel) return;

            // Find the slide that contains this label
            const slide = correspondingLabel.closest('.splide__slide');
            if (!slide) return;

            // Try to get the splide instance from Alpine.js store
            let splideInstance = null;
            
            // Method 1: Try direct property
            if (slider.splide) {
              splideInstance = slider.splide;
            }
            // Method 2: Try Alpine.js store
            else if (window.Alpine && window.Alpine.store('xSplide')) {
              try {
                const splideComponents = window.Alpine.store('xSplide').getSplideComponents();
                splideInstance = splideComponents.find(comp => comp.$el === slider);
              } catch (error) {
                // Silently handle errors
              }
            }
            
            if (splideInstance) {
              this.performScrollWithInstance(splideInstance, slide);
              return;
            }

            // If Splide isn't ready yet, wait for it to be ready
            const waitForSplide = () => {
              if (slider.splide) {
                this.performScroll(slider, slide);
                return;
              }
              
              // Listen for Splide ready event
              let retryCount = 0;
              const maxRetries = 60; // Maximum 1 second at 60fps
              
              const checkSplideReady = () => {
                if (slider.splide) {
                  this.performScroll(slider, slide);
                } else if (retryCount < maxRetries) {
                  // Check again on next frame
                  retryCount++;
                  requestAnimationFrame(checkSplideReady);
                }
                // If max retries reached, silently fail
              };
              
              checkSplideReady();
            };
            
            waitForSplide();
          });
        },

        performScroll(slider, slide) {
          // Find the index of the slide
          const slides = slider.querySelectorAll('.splide__slide');
          const slideIndex = Array.from(slides).indexOf(slide);
          
          if (slideIndex !== -1) {
            // Scroll to the selected slide
            try {
              slider.splide.go(slideIndex);
            } catch (error) {
              // Silently handle errors
            }
          }
        },

        performScrollWithInstance(splideInstance, slide) {
          // Check if splideInstance has the required properties
          if (!splideInstance || !splideInstance.$el || !splideInstance.splide) {
            return;
          }
          
          // Find the index of the slide
          const slides = splideInstance.$el.querySelectorAll('.splide__slide');
          const slideIndex = Array.from(slides).indexOf(slide);
          
          if (slideIndex !== -1) {
            // Scroll to the selected slide
            try {
              splideInstance.splide.go(slideIndex);
            } catch (error) {
              // Silently handle errors
            }
          }
        },

        initializeAllProductCards() {
          // Initialize scrolling for all product cards on page load
          const productCards = document.querySelectorAll('.card-product');
          
          if (productCards.length === 0) {
            return;
          }
          
          // Wait for all cards to have the required elements before proceeding
          let retryCount = 0;
          const maxRetries = 60; // Maximum 1 second at 60fps
          
          const waitForAllCardsReady = () => {
            const allCardsReady = Array.from(productCards).every(card => 
              card.querySelector('.swatch-slider') && card.querySelector('.current-variant')
            );
            
            if (allCardsReady) {
              // Now initialize each card
              productCards.forEach((card, index) => {
                // Find the section ID from the card
                const variantUpdate = card.querySelector('[id^="variant-update-"]');
                if (variantUpdate) {
                  const sectionId = variantUpdate.id.replace('variant-update-', '');
                  this.scrollToSelectedVariant(card, sectionId);
                }
              });
              
              // After initializing, create hover images
              this.createHoverImagesForAllCards();
            } else if (retryCount < maxRetries) {
              // Check again on next frame
              retryCount++;
              requestAnimationFrame(waitForAllCardsReady);
            }
            // If max retries reached, silently fail
          };
          
          waitForAllCardsReady();
        },

        handleColorFilterSelection() {
          // Handle automatic variant selection when color filters are applied
          const productCards = document.querySelectorAll('.card-product');
          
          productCards.forEach((card, index) => {
            // Check if this card has a matching variant (color filter applied)
            const matchingVariant = card.dataset.matchingVariant;
            if (matchingVariant && matchingVariant !== 'none') {
              // Find the section ID from the card
              const variantUpdate = card.querySelector('[id^="variant-update-"]');
              if (variantUpdate) {
                const sectionId = variantUpdate.id.replace('variant-update-', '');
                
                // Get the current variant selection
                const currentVariantElement = card.querySelector('.current-variant');
                const currentVariantId = currentVariantElement ? currentVariantElement.textContent : 'none';
                
                // Wait for DOM to be ready, then scroll and create hover image
                let retryCount = 0;
                const maxRetries = 60; // Maximum 1 second at 60fps
                
                const waitForDOMReady = () => {
                  if (card.querySelector('.swatch-slider') && card.querySelector('.current-variant')) {
                    this.scrollToSelectedVariant(card, sectionId);
                    
                    // After scrolling, create hover image for this variant
                    const currentVariantElement = card.querySelector('.current-variant');
                    const currentVariantId = currentVariantElement ? currentVariantElement.textContent.trim() : 'none';
                    try {
                      this.updateSecondImage(card, currentVariantId);
                    } catch (error) {
                      // Silent error for other cards
                    }
                  } else if (retryCount < maxRetries) {
                    // Check again on next frame
                    retryCount++;
                    requestAnimationFrame(waitForDOMReady);
                  }
                  // If max retries reached, silently fail
                };
                
                waitForDOMReady();
              } else if (index === 0) {
                // Silent for other cards
              }
            } else if (index === 0) {
              // Silent for other cards
            }
          });
          
          // After handling color filters, ensure all cards have hover images
          // Wait for all cards to be processed, then create hover images
          let retryCount = 0;
          const maxRetries = 60; // Maximum 1 second at 60fps
          
          const waitForAllCardsReady = () => {
            const allCardsReady = Array.from(productCards).every(card => 
              card.querySelector('.swatch-slider') && card.querySelector('.current-variant')
            );
            
            if (allCardsReady) {
              this.createHoverImagesForAllCards();
            } else if (retryCount < maxRetries) {
              // Check again on next frame
              retryCount++;
              requestAnimationFrame(waitForAllCardsReady);
            }
            // If max retries reached, silently fail
          };
          
          waitForAllCardsReady();
        },

        createHoverImagesForAllCards() {
          const productCards = document.querySelectorAll('.card-product');
          
          productCards.forEach((card, index) => {
            const productId = card.dataset.productId;
            if (productId) {
              const currentVariantElement = card.querySelector('.current-variant');
              if (currentVariantElement) {
                const currentVariantId = currentVariantElement.textContent.trim();
                if (currentVariantId && currentVariantId !== 'none') {
                  this.updateSecondImage(card, currentVariantId);
                } else {
                  // Fallback to product ID if no variant is selected
                  this.updateSecondImage(card, productId);
                }
              } else {
                // Fallback to product ID if no current variant element
                this.updateSecondImage(card, productId);
              }
            }
          });
        },

        updateImage(el, productUrl, src, variantId, sectionId, hasVariant) {
          const cardProduct = el.closest('.card-product');
          let getLink =  productUrl + `?variant=${variantId}`;
          if (!cardProduct) return;
          const linkVariant = cardProduct.getElementsByClassName("link-product-variant");
          for (var i = 0; i < linkVariant.length; i ++) {
            linkVariant[i].setAttribute("href", getLink);
          }
          const currentVariant = cardProduct.querySelector(".current-variant");
          if (currentVariant && !hasVariant) {
            currentVariant.innerText = variantId;
          }

          // Parse product JSON once per call (was parsed again inside updateSecondImage).
          const productData = this.getProductData(cardProduct);
          this.updateSecondImage(cardProduct, variantId, productData);

          if (productData) {
            const targetVariant = productData.variants.find(variant => variant.id == variantId);
            let mainImage = null;
            if (targetVariant && targetVariant.featured_image) {
              mainImage = targetVariant.featured_image;
            } else if (productData.featured_image) {
              mainImage = productData.featured_image;
            } else if (productData.media && productData.media.length > 0) {
              mainImage = productData.media[0];
            }
            this.updateMainImageInDOM(cardProduct, mainImage);
          }

          if (src != '') {
            let media = cardProduct.querySelector(`[media="${src}"]`);
            if (media) {
              let index = media.getAttribute('index');
              let slide = cardProduct.querySelector('.x-splide');
              if (slide) {
                if (slide.splide) {
                  slide.splide.go(Number(index));
                } else {
                  document.addEventListener(`eurus:${sectionId}:splide-ready`, () => {
                    slide.splide.go(Number(index));
                  }, { once: true });
                }
                return;
              } 
            }
            const previewImg = cardProduct.getElementsByClassName("preview-img")[0];
            if (!previewImg) return;
            previewImg.removeAttribute("srcset");
            previewImg.setAttribute("src", this.resizeImageUrl(src, 600));
            let slide = cardProduct.querySelector('.x-splide');
            if (slide && slide.splide) {
              slide.splide.go(0);
            }
          } else {
            let slide = cardProduct.querySelector('.x-splide');
            if (slide && slide.splide) {
              slide.splide.go(0);
            }
          }
        },

        // Cap CDN width for collection/product cards (~1/5 viewport). Full Shopify URLs over-fetch.
        resizeImageUrl(src, width = 600) {
          if (!src) return src;
          const baseUrl = src.split('?')[0];
          return `${baseUrl}?width=${width}`;
        },

        updateMainImageInDOM(cardProduct, mainImage) {
          const imageContainer = cardProduct.querySelector('.card-product-image-container');
          if (!imageContainer) return;
          const mainImg = imageContainer.querySelector('.main-image');
          if (!mainImg || !mainImage) return;
          // Support both Shopify image object and our extracted media object
          let src = mainImage.src || (mainImage.preview_image && mainImage.preview_image.src);
          if (!src && typeof mainImage === 'string') src = mainImage;
          if (!src) return;
          mainImg.src = this.resizeImageUrl(src, 600);
          mainImg.srcset = this.generateSrcset(src);
          mainImg.alt = mainImage.alt || mainImg.alt || '';
        },

        updateSecondImage(cardProduct, variantId, productData = null) {
          
          if (!cardProduct || !variantId) {
            return;
          }
          
          // Reuse parsed data from updateImage when provided.
          productData = productData || this.getProductData(cardProduct);
          if (!productData) {
            return;
          }

          // Find the variant that matches the variantId
          const targetVariant = productData.variants.find(variant => variant.id == variantId);
          if (!targetVariant) {
            return;
          }

          // Get the color option value from the variant
          const colorOptionValue = this.getColorOptionValue(targetVariant, productData.options);
          if (!colorOptionValue) {
            return;
          }

          // Get the main image for comparison
          const mainImage = targetVariant.featured_image || productData.featured_media;

          // Find matching second image based on color option and alt tags
          const secondImage = this.findMatchingSecondImage(productData.media, colorOptionValue, mainImage);
          
          // Update the second image in the DOM
          this.updateSecondImageInDOM(cardProduct, secondImage);
        },

        getProductData(cardProduct) {
          if (!cardProduct) return null;
          if (this._productDataCache.has(cardProduct)) {
            return this._productDataCache.get(cardProduct);
          }

          // Try to get product data from the script tag with data-product-data attribute
          const productId = cardProduct.dataset.productId;
          if (!productId) {
            return null;
          }

          // Look for the script tag with data-product-data attribute
          const productDataElement = cardProduct.querySelector(`script[data-product-data="${productId}"]`);
          if (productDataElement) {
            try {
              const productData = JSON.parse(productDataElement.textContent);
              this._productDataCache.set(cardProduct, productData);
              return productData;
            } catch (e) {
              return null;
            }
          }

          return null;
        },

        invalidateProductData(cardProduct) {
          if (cardProduct) this._productDataCache.delete(cardProduct);
        },

        extractProductDataFromCard(cardProduct) {
          // Extract media data from the card's DOM structure
          const mediaElements = cardProduct.querySelectorAll('img[src*="/products/"]');
          const media = [];
          
          mediaElements.forEach((img, index) => {
            if (img.src && img.alt) {
              media.push({
                id: index,
                src: img.src,
                alt: img.alt,
                width: img.naturalWidth || 0,
                height: img.naturalHeight || 0
              });
            }
          });

          // Get variant data from radio inputs and their associated labels
          const variantInputs = cardProduct.querySelectorAll('input[type="radio"][name*="option"]');
          const variants = [];
          const options = [];

          // Group inputs by option name to build complete variant data
          const optionGroups = {};
          
          variantInputs.forEach(input => {
            const optionName = input.name;
            const optionValue = input.value;
            const variantId = input.getAttribute('data-variant-id') || input.value;
            
            if (!optionGroups[optionName]) {
              optionGroups[optionName] = [];
            }
            optionGroups[optionName].push(optionValue);
            
            // Try to find existing variant or create new one
            let variant = variants.find(v => v.id == variantId);
            if (!variant) {
              variant = {
                id: variantId,
                option1: null,
                option2: null,
                option3: null,
                options: []
              };
              variants.push(variant);
            }
            
            // Determine which option this is (option1, option2, option3)
            const optionIndex = Object.keys(optionGroups).indexOf(optionName);
            if (optionIndex === 0) {
              variant.option1 = optionValue;
            } else if (optionIndex === 1) {
              variant.option2 = optionValue;
            } else if (optionIndex === 2) {
              variant.option3 = optionValue;
            }
            
            if (!variant.options.includes(optionValue)) {
              variant.options.push(optionValue);
            }
          });

          // Build options array
          Object.keys(optionGroups).forEach(optionName => {
            options.push({
              name: optionName,
              values: optionGroups[optionName]
            });
          });

          return {
            id: cardProduct.dataset.productId,
            media: media,
            variants: variants,
            options: options
          };
        },

        getColorOptionValue(variant, options) {
          // Always return the first option value for the variant (usually color)
          return variant.option1;
        },

        findMatchingSecondImage(media, colorOptionValue, mainImage) {
          if (!colorOptionValue || !media || media.length < 2) {
            return media[1]; // Fallback to second media item
          }
          
          // First, try to find images that are specifically tagged for this color variant
          const colorValueLower = colorOptionValue.toLowerCase().replace(/\s+/g, '-');
          const expectedAltTags = [
            `#color_${colorValueLower}`,
            `#${colorValueLower}`,
            colorValueLower
          ];
          
          // Look for images with color-specific alt tags first
          for (const mediaItem of media) {
            if (!mediaItem.alt || typeof mediaItem.alt !== 'string') {
              continue;
            }
            const altLower = mediaItem.alt.toLowerCase();
            for (const expectedTag of expectedAltTags) {
              // More precise matching - check for exact match or word boundaries
              if (altLower === expectedTag || 
                  altLower.includes(` ${expectedTag} `) || 
                  altLower.endsWith(` ${expectedTag}`) || 
                  altLower.startsWith(`${expectedTag} `) ||
                  altLower === expectedTag) {
                  
                  // Check if this color-specific image is different from the main image
                  const isDifferent = mediaItem.src !== mainImage?.src && mediaItem.id !== mainImage?.id;
                  
                  if (isDifferent) {
                    return mediaItem;
                  } else {
                    // Continue looking for other images
                  }
                }
              }
            }
            
            // If no suitable color-specific image found, look for the next different image
            // This ensures we get a different image for hover, not the same as the main image
            if (media.length >= 2) {
              // Start from the second image and find the first one that's different from the main image
              for (let i = 1; i < media.length; i++) {
                const mediaItem = media[i];
                const isDifferent = mediaItem.src !== mainImage?.src && mediaItem.id !== mainImage?.id;
                
                // Check if this image is different from the main image (first image)
                if (isDifferent) {
                  return mediaItem;
                }
              }
              
              // If all images are the same, return null to disable hover
              return null;
            }
            
            // If we only have one image, return null to disable hover
            return null;
          },

        updateSecondImageInDOM(cardProduct, secondImage) {
          const imageContainer = cardProduct.querySelector('.card-product-image-container');
          if (!imageContainer) return;

          let hoverImg = imageContainer.querySelector('.hover-image');

          if (secondImage) {
            let src = secondImage.src || (secondImage.preview_image && secondImage.preview_image.src);

            if (!hoverImg) {
              // Create hover image if it doesn't exist
              hoverImg = document.createElement('img');
              hoverImg.className = 'hover-image w-full h-full object-cover absolute top-0 left-0 opacity-0 transition-opacity duration-300';
              hoverImg.loading = 'lazy';
              imageContainer.appendChild(hoverImg);
            }

            hoverImg.src = this.resizeImageUrl(src, 600);
            hoverImg.alt = secondImage.alt || '';
            hoverImg.srcset = this.generateSrcset(src);

            // Remove any manual event listeners since CSS handles the hover
            imageContainer.onmouseenter = null;
            imageContainer.onmouseleave = null;
            
            // Ensure the hover image is visible but with opacity 0 initially
            hoverImg.style.opacity = '0';
          } else if (hoverImg) {
            // If no second image, hide the hover image and disable hover functionality
            hoverImg.style.opacity = '0';
            hoverImg.style.pointerEvents = 'none';
            // Remove hover event listeners to disable hover
            imageContainer.onmouseenter = null;
            imageContainer.onmouseleave = null;
          }
        },

        generateSrcset(src) {
          // Match collection card widths (cards are ~1/5 viewport)
          const baseUrl = src.split('?')[0];
          const sizes = [300, 375, 450, 600, 750, 900];
          return sizes.map(size => `${baseUrl}?width=${size} ${size}w`).join(', ');
        },

        updateQuickAdd(productUrl, variantId, quickAddPageParam, productId){
          let url = `${productUrl}?variant=${variantId}&section_id=choose-option&page=${quickAddPageParam}`
          fetch(url)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const listCurrent = document.querySelectorAll(`#product-form-choose-option${productId}${quickAddPageParam}`);
            const destination = html.querySelector(`#product-form-choose-option${productId}${quickAddPageParam}`);
            if(listCurrent.length>0 && destination){
              listCurrent.forEach((item)=>{
                item.innerHTML = destination.innerHTML;
                const currentPrice = item.closest('.card-product').querySelector(".main-product-price");
                const updatePrice = html.querySelector(".main-product-price");
                if(currentPrice && updatePrice){
                  currentPrice.innerHTML = updatePrice.innerHTML
                }
              })
            }
          })
        },

        /**
         * Ensure Liquid-selected / locked matching_variant stays the active selection
         * (checked swatch + .current-variant for Quick View). Images follow normal
         * updateImage path for that variant — no special hover/main heuristics.
         */
        selectLockedMatchingVariants() {
          document.querySelectorAll('.card-product[data-variant-locked="true"]').forEach((card) => {
            const variantId = card.dataset.matchingVariant;
            if (!variantId || variantId === 'none') return;

            const productData = this.getProductData(card);
            const locked = productData?.variants?.find((v) => String(v.id) === String(variantId));
            if (!locked) return;

            const currentVariantElement = card.querySelector('.current-variant');
            if (currentVariantElement) {
              currentVariantElement.textContent = variantId;
            }

            // Check the color radio that matches the locked variant option1.
            if (locked.option1) {
              const radios = card.querySelectorAll('input[type="radio"][option-pos="1"]');
              radios.forEach((radio) => {
                if (radio.value === locked.option1) {
                  radio.checked = true;
                }
              });
            }

            const variantUpdate = card.querySelector('[id^="variant-update-"]');
            const sectionId = variantUpdate
              ? variantUpdate.id.replace('variant-update-', '')
              : '';
            const productUrl =
              card.querySelector('a.link-product-variant')?.getAttribute('href')?.split('?')[0] ||
              '';

            if (productUrl) {
              // Drive the normal image/link update for this variant id.
              this.updateImage(card, productUrl, '', variantId, sectionId);
            }

            if (sectionId) {
              this.scrollToSelectedVariant(card, sectionId);
            }
          });
        },

        handleShowFirstMetafieldVariants() {
          // Handle variants with show_first metafield set to true
          const productCards = document.querySelectorAll('.card-product');
          
          productCards.forEach((card) => {
            // Check if this card has active color filtering applied
            const activeColors = card.dataset.activeColors;
            const hasColorFilter = activeColors && activeColors !== '' && activeColors !== 'undefined';
            
            // If color filtering is active, skip show_first logic to preserve color filtering
            if (hasColorFilter) {
              return;
            }

            // Bestseller clones / preselect: Liquid already chose matching_variant.
            if (
              card.dataset.variantLocked === 'true' ||
              (card.dataset.matchingVariant && card.dataset.matchingVariant !== 'none' && card.closest('.grid-item--bestseller-repeat'))
            ) {
              return;
            }
            
            // Get the product data from the card
            const productData = this.getProductData(card);
            if (!productData || !productData.variants) {
              return;
            }

            // Find variants with show_first metafield set to true
            const showFirstVariants = productData.variants.filter(variant => 
              variant.metafields && 
              variant.metafields.custom && 
              variant.metafields.custom.show_first === true
            );

            if (showFirstVariants.length > 0) {
              // Get the first show_first variant
              const showFirstVariant = showFirstVariants[0];
              
              // Find the section ID from the card
              const variantUpdate = card.querySelector('[id^="variant-update-"]');
              if (variantUpdate) {
                const sectionId = variantUpdate.id.replace('variant-update-', '');
                
                // Update the current variant display
                const currentVariantElement = card.querySelector('.current-variant');
                if (currentVariantElement) {
                  currentVariantElement.textContent = showFirstVariant.id;
                }

                // Wait for DOM to be ready, then scroll and create hover image
                let retryCount = 0;
                const maxRetries = 60; // Maximum 1 second at 60fps
                
                const waitForDOMReady = () => {
                  if (card.querySelector('.swatch-slider') && card.querySelector('.current-variant')) {
                    // Scroll to the selected variant in the swatch slider
                    this.scrollToSelectedVariant(card, sectionId);
                    
                    // After scrolling, create hover image for this variant
                    try {
                      this.updateSecondImage(card, showFirstVariant.id);
                    } catch (error) {
                      // Silent error handling
                    }
                  } else if (retryCount < maxRetries) {
                    // Check again on next frame
                    retryCount++;
                    requestAnimationFrame(waitForDOMReady);
                  }
                  // If max retries reached, silently fail
                };
                
                waitForDOMReady();
              }
            }
          });
        }
      });
    })
  });
}    

// Initialize scrolling for all product cards when the page loads
document.addEventListener('DOMContentLoaded', () => {
  // Function to initialize when Alpine is ready
  const initializeWhenReady = () => {
    if (window.Alpine && window.Alpine.store('xPreviewColorSwatch')) {
      const store = window.Alpine.store('xPreviewColorSwatch');
      store.initializeAllProductCards();
      store.handleColorFilterSelection();
      store.handleShowFirstMetafieldVariants();
      store.selectLockedMatchingVariants();
      setTimeout(() => store.selectLockedMatchingVariants(), 150);
      return true;
    }
    return false;
  };

  // Try to initialize immediately
  if (!initializeWhenReady()) {
    // If Alpine isn't ready yet, wait for it
    document.addEventListener('alpine:init', () => {
      // Try to initialize after Alpine is initialized
      if (!initializeWhenReady()) {
        // If still not ready, wait for the next tick with retry limit
        let retryCount = 0;
        const maxRetries = 60; // Maximum 1 second at 60fps
        
        const retryInitialize = () => {
          if (!initializeWhenReady() && retryCount < maxRetries) {
            retryCount++;
            requestAnimationFrame(retryInitialize);
          }
        };
        
        requestAnimationFrame(retryInitialize);
      }
    });
  }
  
  // Also listen for Alpine fully initialized event
  document.addEventListener('alpine:initialized', () => {
    initializeWhenReady();
  });
  
  // Start content change detection immediately
  if (window.reinitializeScrollingOnContentChange) {
    window.reinitializeScrollingOnContentChange();
  }
  
  // Wait for window load event (when all resources are loaded)
  window.addEventListener('load', () => {
    // Final attempt to initialize any missed cards
    initializeWhenReady();
  });
});



// Method to detect page content changes and reinitialize
window.reinitializeScrollingOnContentChange = () => {
  // Single function to recreate hover images
  const recreateHoverImages = () => {
    if (window.Alpine && window.Alpine.store('xPreviewColorSwatch')) {
      const store = window.Alpine.store('xPreviewColorSwatch');
      store.initializeAllProductCards();
      store.handleColorFilterSelection();
      store.handleShowFirstMetafieldVariants();
      store.selectLockedMatchingVariants();
      setTimeout(() => store.selectLockedMatchingVariants(), 150);
    }
  };

  // Listen for the custom colorFilterChanged event from facets.js
  document.addEventListener('colorFilterChanged', (event) => {
    recreateHoverImages();
  });

  // Listen for form submissions on the FacetFiltersForm
  document.addEventListener('submit', (event) => {
    if (event.target.id === 'FacetFiltersForm') {
      recreateHoverImages();
    }
  });

  // Listen for URL hash changes (filter state changes)
  window.addEventListener('hashchange', (event) => {
    recreateHoverImages();
  });

  // Listen for popstate events (browser back/forward)
  window.addEventListener('popstate', (event) => {
    recreateHoverImages();
  });

  // Listen for any custom filter events
  document.addEventListener('filterApplied', (event) => {
    recreateHoverImages();
  });

  // Listen for input changes on filter elements
  document.addEventListener('change', (event) => {
    if (event.target.closest('.facets__form') || event.target.closest('#FacetFiltersForm')) {
      recreateHoverImages();
    }
  });

  // MutationObserver as a fallback - detects when DOM actually changes
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList' && mutation.target.id === 'ProductGridContainer') {
        recreateHoverImages();
      }
    });
  });
  
  const productGridContainer = document.getElementById('ProductGridContainer');
  if (productGridContainer) {
    observer.observe(productGridContainer, { childList: true, subtree: true });
  }
};    
